const { REACT_APP_CONTENTS_URL, REACT_APP_CONTENTS_TOKEN } = process.env;

export const quickMenuApi = (storeId) => {
  return {
    headers: {
      emquest_access_token: REACT_APP_CONTENTS_TOKEN,
    },
    apiUrl: REACT_APP_CONTENTS_URL + `/menu`,
  };
};
